<div class="subsection" [class.enabled]="isEnabled">
    <!-- Toggle Field as Header -->
    <div class="subsection-header">
        <div class="toggle-container">
            <app-toggle-switch [label]="subsection.toggleField.fieldLabel" [dataId]="subsection.toggleField.fieldName"
                [control]="getFormControl(subsection.toggleField.fieldName)" [required]="false">
            </app-toggle-switch>
        </div>
    </div>

    <!-- Conditional Fields in Grid Layout -->
    <div class="subsection-fields" [class.disabled]="!isEnabled">
        <div class="fields-grid">
            @for (field of subsection.fields; track field) {
<div class="field-container"
                [class.hidden]="!shouldShowField(field)" [class.full-width]="field.fullWidth">

                <!-- Text input -->
                @if (field.fieldType === 'text') {
<app-textbox [label]="field.fieldLabel"
                    [placeholder]="field.placeholder || ''" [control]="getFormControl(field.fieldName)"
                    [dataId]="field.fieldName" [required]="field.required" [disabled]="!isEnabled || disabled">
                </app-textbox>
}

                <!-- Number input -->
                @if (field.fieldType === 'number') {
<app-textbox [label]="field.fieldLabel"
                    [placeholder]="field.placeholder || ''" [control]="getFormControl(field.fieldName)"
                    [dataId]="field.fieldName" [required]="field.required" [type]="'number'" [min]="field.min"
                    [max]="field.max" [step]="field.step" [decimalSupport]="field.decimalSupport"
                    [disabled]="!isEnabled || disabled">
                </app-textbox>
}

                <!-- Password input -->
                @if (field.fieldType === 'password') {
<app-textbox [label]="field.fieldLabel"
                    [dataId]="field.fieldName" [placeholder]="field.placeholder"
                    [control]="getFormControl(field.fieldName)" [required]="field.required" [type]="'password'"
                    [disabled]="!isEnabled || disabled">
                </app-textbox>
}

                <!-- Toggle input -->
                @if (field.fieldType === 'toggle') {
<app-toggle-switch [label]="field.fieldLabel"
                    [dataId]="field.fieldName" [control]="getFormControl(field.fieldName)" [required]="field.required">
                </app-toggle-switch>
}

                <!-- Dropdown -->
                @if (field.fieldType === 'dropdown') {
<app-dropdown [label]="field.fieldLabel"
                    [dataId]="field.fieldName" [placeholder]="field.placeholder" [options]="field.options"
                    [control]="getFormControl(field.fieldName)" [required]="field.required"
                    [disabled]="!isEnabled || disabled">
                </app-dropdown>
}

                <!-- Radio button group -->
                @if (field.fieldType === 'radio') {
<app-radio-button-group [label]="field.fieldLabel"
                    [dataId]="field.fieldName" [options]="field.options" [control]="getFormControl(field.fieldName)"
                    [required]="field.required" [disabled]="!isEnabled || disabled">
                </app-radio-button-group>
}

                <!-- Checkbox group -->
                @if (field.fieldType === 'checkbox') {
<app-checkbox-group [label]="field.fieldLabel"
                    [dataId]="field.fieldName" [options]="field.options" [control]="getFormControl(field.fieldName)"
                    [required]="field.required" [disabled]="!isEnabled || disabled">
                </app-checkbox-group>
}

            </div>
}
        </div>
    </div>
</div>